import React from "react";
import Logo from "../assets/images/banner-img.png";
// import { socialList } from "../utils/data";
const Footer = () => {
  return (
    <div>
      <div className="container py-20 font-serif">
        <div>
          <img src={Logo} className="mx-auto w-40" alt="" />
          <div className="border-y border-white mt-10 border-opacity-20 py-2 flex flex-col md:flex-row justify-between items-center">
            <div className="mx-auto my-4 text-center md:text-right text-sm md:text-base">
              © 2022 <span className="text-primary">MOZZLE DOGE</span> — All
              rights reserved.
            </div>
            {/* <div className=" flex  my-8 md:mx-10 mx-auto">
              {socialList.map((val, i) => (
                <div
                  className=" text-2xl md:text-4xl px-4 py-2 border-x border-white border-opacity-20"
                  key={i}
                >
                  <a href={val.link}>{val.icon}</a>
                </div>
              ))}
            </div> */}
            {/* <div className="flex-1 text-left text-sm md:text-base">
              {" "}
              PRIVACY POLIY&nbsp; | &nbsp;TERM & CONDITION
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
